/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { Form, Grid } from '@mairistem/composants';
import { SectionHeader } from '@mairistem/administres-utils';

import { STYLE_TITRE_SECTION } from '@/components/Common';

interface InformationsOfficierProps {
  data: Record<string, any>;
  errors?: Record<string, string>;
  onChange: (event: React.SyntheticEvent | null, payload: any) => void;
}

/**
 * Sous-bloc « Officier d'état civil » de l'étape Acte d'un mariage : qui a
 * célébré, et à quel titre.
 *
 * ⚠️ Trois champs STRUCTURÉS, et non la phrase que le client historique
 * fabriquait dans `am_a_sign` (« , Robert BENEVENTI, Maire d'Ollioules,
 * officier de l'Etat Civil. », parfois stockée en RTF). Cette colonne reste
 * vide : reproduire sa mise en forme serait la deviner.
 *
 * Sous-bloc et non `Section` : la maquette le range sous les informations de
 * l'acte, dont il fait partie.
 */
const InformationsOfficier = (props: InformationsOfficierProps) => {
  const { data, errors = {}, onChange } = props;

  return (
    <>
      {/* @ts-ignore */}
      <SectionHeader
        title="Officier d'état civil"
        required={false}
        style={STYLE_TITRE_SECTION}
      />
      <Grid>
        <Grid.Row style={{ paddingLeft: '1em' }}>
          <Grid.Column computer={5} tablet={8} mobile={16}>
            <Form.Input
              fluid
              label="Nom"
              name="officierNomFamille"
              // ec_actm.am_a_sign_nom_famille est un varchar(50).
              maxLength={50}
              error={!!errors?.officierNomFamille}
              value={data?.officierNomFamille ?? ''}
              onChange={onChange}
            />
          </Grid.Column>
          <Grid.Column computer={5} tablet={8} mobile={16}>
            <Form.Input
              fluid
              label="Prénom"
              name="officierPrenoms"
              // am_a_sign_prenoms est un varchar(100).
              maxLength={100}
              error={!!errors?.officierPrenoms}
              value={data?.officierPrenoms ?? ''}
              onChange={onChange}
            />
          </Grid.Column>
          <Grid.Column computer={6} tablet={16} mobile={16}>
            <Form.Input
              fluid
              // Libellé de la maquette : c'est la QUALITÉ du signataire
              // (« Adjoint au Maire d'Ollioules »), colonne am_a_sign_qualite.
              label="Grade signataire"
              name="officierQualite"
              maxLength={100}
              error={!!errors?.officierQualite}
              value={data?.officierQualite ?? ''}
              onChange={onChange}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </>
  );
};

export default InformationsOfficier;
